const hasAnyAuthToeken = (stateToken: string | null, localStorageToken: string | null, setAuth: (args1: string) => void): string | null => {
    if(stateToken) return stateToken;

    if(localStorageToken) {
        setAuth(localStorageToken);
        return localStorageToken;
    }

    return null
}

export {
    hasAnyAuthToeken
}